<template>
  <div class="variable-selector">
    <!--<label v-if="label">{{ label }}</label>-->
    <b-form-select
      class="variableList"
      v-model="selectedVariable"
      @change="onChange"
      size="lg"
      title="Meteorológiai elemek, éghajlati változók kiválasztása"
    >
      <template #first>
        <b-form-select-option :value="null" selected hidden disabled
          >Változók</b-form-select-option
        >
      </template>

      <b-form-select-option
        v-for="variable in variableList"
        :key="variable.variable_notation"
        :value="variable.variable_notation"
        v-b-tooltip.hover
        :title="variable.tooltip"
        >{{ variable.variable_name }}</b-form-select-option
      >
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "VariableSelector",
  props: {
    variableMap: {
      type: Map,
      default: () => new Map(),
    },
    value: {
      type: String,
      default: "",
    },
    viewType: {
      type: String,
      default: "mapView",
    },
    modelType: {
      type: String,
      default: "climate",
    },
    propSelectedVariable: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedVariable: null, //this.value,
    };
  },
  computed: {
    variableList() {
      let viewType = this.viewType;
      let modelType = this.modelType;
      console.log(this.variableMap);
      //Itt miért van szükség a has-ra?
      if (this.variableMap.has("mapView")) {
        let localVariableMap = this.variableMap.get(viewType).get(modelType);
        if (!localVariableMap.has(this.selectedVariable)) {
          if (this.selectedVariable) {
            let variable_notation_array = Array.from(localVariableMap.keys());
            this.selectedVariable = variable_notation_array[0];
          } else {
            this.selectedVariable = null;
          }
          //this.selectedVariable = null; //Ez miért nem védi ki a hibát?
          //Ki kellene nullázni a selectedVariable-t, a store-ban is
          //mi van graph view esetén?
        }
        return Array.from(localVariableMap.values());
      }
      //TODO: itt meg kell vizsgálni, hogy az aktuális változó benne van-e a listában
      return [];
    },
  },
  watch: {
    value(newVal) {
      this.selectedVariable = newVal;
      console.warn("variable selector value prop changed:", newVal);
    },
    propSelectedVariable(newVal) {
      this.selectedVariable = newVal;
      console.warn("variable selector propSelectedVariable changed:", newVal);
    },
    selectedVariable(newVal) {
      this.$emit("input", newVal);
    },
  },
  methods: {
    onChange() {
      //this.$emit('input', this.selectedVariable);
      this.$emit("selectedVariableChanged", this.selectedVariable);
    },
  },
};
</script>

<style scoped>
.variable-selector {
  margin-bottom: 1rem;
}
.variableList {
  flex-grow: 1;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.variable-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 1rem;
}
</style>
